export const pageName = {
  ACCEPT: "Accept-And-Proceed",
  PERSONAL: "Your-Details-Personal-Information",
  CONTACT: "Your-Details-Contact-Information",
  COVER: "Select-Cover",
  QUOTE: "Quote-Summary",
  ABOUT_YOU_DISCLOSURE: "About-You-Duty-Of-Disclosure",
  ABOUT_YOU_QUESTIONS: "About-You-Questions",
  REVIEW_APPLICATION: "review-application",
  PP_CONTACT: "Payment-Contact-Details", //Shared
  PP_ONLINE_PAYMENT: "Online-Payment-Details",
  PP_ONLINE_POLICY_OUTCOME: "Online-Policy-Outcome",
  PP_CONFIRMATION: "Policy-confirmation",
  CC_OPENING_SCRIPT: "Opening-Script",
  PP_CC_PAYMENT: "CC-Payment-Details",
  PP_CC_POLICY_OUTCOME: "CC-Policy-Outcome",
  PP_POLICY_OUTCOME_DECLINE: "Policy-Outcome-Decline",
  PP_CC_UPGRADE_SAVE_CONFIRMATION: "CC-Upgrade-Save-Confirmation",
  PP_POLICY_PURCHASE_CONFIRMATION: "Policy-Purchase-Confirmation",
  INFO_AND_DUTY: "Information-and-Duty",
  RETRIEVE_QUOTE_LOADING: "Retrieve-Quote-Loading",
  RETRIEVE_QUOTE_DECLINE: "Retrieve-Quote-Decline",
  RETRIEVE_QUOTE_EXPIRED: "Retrieve-Quote-Expired",
  RETRIEVE_QUOTE_REFERRED_UW: "Retrieve-Quote-Referred-UW",
  RETRIEVE_QUOTE_BOUND: "Retrieve-Quote-Bound",
  CC_PROCESSING_LANDING_PAGE: "Processing-Landing-Page",
  CC_RETRIEVE_QUOTE_PAGE: "Retrieve-Quote-Page",
  APPLICATION_ALREADY_DECLINED: "Application-Already-Declined",
};

export const isQuotePages = (currentPageName) =>
  [
    pageName.ACCEPT,
    pageName.PERSONAL,
    pageName.CONTACT,
    pageName.COVER,
    pageName.QUOTE,
    pageName.CC_OPENING_SCRIPT,
  ].indexOf(currentPageName) != -1;
